import { environment } from '@brighthub/environment';
import { prepareClientSearch } from './client-search-query.util';

export interface ClientSearchAmplitudeOptions {
  /** When set, overrides {@link environment.production} (e.g. unit tests). */
  productionOverride?: boolean;
}

/** Amplitude-safe props: never includes raw name queries in production. */
export function clientSearchAmplitudeProps(
  rawQuery: string,
  options?: ClientSearchAmplitudeOptions
): Record<string, unknown> {
  const prep = prepareClientSearch(rawQuery);
  const trimmedLen = rawQuery.trim().length;
  const hadWildcard = rawQuery.includes('*');
  const isProd =
    options?.productionOverride ?? environment.production;

  if (prep.kind === 'skip') {
    return {
      searchKind: 'skip',
      queryLength: trimmedLen,
      hadWildcard,
    };
  }

  const searchType = prep.searchType;
  if (isProd) {
    if (searchType === 'name') {
      return { searchType, queryLength: trimmedLen, hadWildcard };
    }
    return { searchType, queryLength: trimmedLen };
  }

  return {
    searchType,
    query: rawQuery.trim(),
    queryLength: trimmedLen,
    hadWildcard,
  };
}
